<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <date-field
          v-model="flightGlider.date"
          field-name="date"
          rules="required|date"
          autofocus
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightGlider.plane_id"
          field-name="reg_num"
          source-type="planes-all"
          filter="plc_02"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <time-field
          v-model="flightGlider.takeoff_time"
          field-name="takeoff_time"
          rules="required|time"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <time-field
          v-model="flightGlider.landing_time"
          field-name="landing_time"
          rules="required|time"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <glider-takeoff-type
          v-model="flightGlider.takeoff_type_id"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightGlider.task_id"
          field-name="task"
          source-type="tasks"
          translate
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightGlider.tow_plane_id"
          :disabled="flightGlider.takeoff_type_id !== 'tof_02'"
          field-name="tow_plane_id"
          label="tow_plane_id"
          source-type="tow-planes"
          rules=""
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <time-field
          v-model="flightGlider.tow_landing_time"
          :disabled="flightGlider.takeoff_type_id !== 'tof_02'"
          field-name="tow_landing_time"
          rules="time"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <airport-selector
          v-model="flightGlider.takeoff_airport_id"
          field-name="airport"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightGlider.pic_id"
          field-name="pic_id"
          label="glider_pic"
          source-type="pilots"
          :disabled="privateRecord"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightGlider.sic_id"
          field-name="sic_id"
          label="glider_sic"
          source-type="pilots"
          rules=""
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightGlider.instructor_id"
          field-name="instructor_id"
          label="instructor_id"
          source-type="instructors"
          rules=""
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightGlider.base_organization_id"
          field-name="organization"
          label="organization"
          source-type="organizations"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="flightGlider.payer_id"
          field-name="payer_id"
          label="payer_id"
          rules=""
          source-type="users"
          :disabled="privateRecord"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="flightGlider.alter_price"
          field-name="alter_price"
          rules="numeric"
          type="number"
          :disabled="privateRecord"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="flightGlider.pay_comment"
          field-name="pay_comment"
          rules="max:500"
          type="text"
          :disabled="privateRecord"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="flightGlider.comment"
          field-name="comment"
          rules="max:500"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="flightGlider.tow_altitude"
          :disabled="flightGlider.takeoff_type_id !== 'tof_02'"
          field-name="tow_altitude"
          rules=""
          type="number"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="flightGlider.cost_sharing"
          :disabled="!flightGlider.sic_id"
          :label="$t('fields.cost_sharing')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditFlightGlider',
    props: {
      flightGlider: Object,
      privateRecord: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>
